<template>
    <div class="position-relative p-3">
        <!-- Begin Page Content -->
        <div class="medical-records">
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="card border-0">
                        <div class="card-header border-0 bg-white d-flex justify-content-between">
                            <h1 class="d-flex justify-content-start align-items-center back-page"><i class="icon icon-chevron-down"></i>Upload Reports</h1>
                            <router-link to="/QR-code-screaner" class="btn btn-gray scan-button"><i class="icon icon-mobile-phone"></i>Continue with Mobile</router-link>
                        </div>
                        <div class="card-body p-0">
                            <div class="bg-white border-radius-5 p-5">
                                <div class="row no-gutters justify-content-center">
                                    <div class="col-md-6 text-center upload-reports">
                                        <form class="mt-5">
                                            <div class="drag-drop">
                                                <input type="file" multiple />
                                                <i class="icon icon-upload-reports"></i>
                                                <h3 class="mt-4">Drag and Drop Files Files To Upload</h3>
                                                <p>you can do this anytime without clicking upload</p>
                                                <span class="d-block">or</span>
                                                <button type="submit" class="btn btn-blue attach">Attach File</button>
                                            </div>
                                            <div class="preview">
                                                <h4 class="mt-5 mb-3 text-left">Uploading</h4>
                                                <div class="file-upload d-flex justify-content-between align-items-center border-radius-5 border-1 bg-white mb-4 p-2">
                                                    <div class="image-upload d-flex align-items-center">
                                                        <figure class="mb-0"><img src="../../../../static/website/images/report.png" alt="" /></figure>
                                                        <h5>Tab-interaction.pdf</h5>
                                                    </div>
                                                    <div class="icons d-fle">
                                                        <a href="#"><i class="icon icon-check-bold"></i></a>
                                                        <a href="#" class="close-icon"><i class="icon icon-close"></i></a>
                                                    </div>
                                                </div>
                                                <div class="file-upload d-flex justify-content-between align-items-center border-radius-5 border-1 bg-white mb-4 p-2">
                                                    <div class="image-upload d-flex align-items-center">
                                                        <figure class="mb-0"><img src="../../../../static/website/images/report.png" alt="" /></figure>
                                                        <h5>Tab-interaction.pdf</h5>
                                                    </div>
                                                    <div class="icons d-fle">
                                                        <a href="#"><i class="icon icon-check-bold"></i></a>
                                                        <a href="#" class="close-icon"><i class="icon icon-close"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <button type="submit" class="btn btn-blue">Upload test Report</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    export default {
        name: "upload-reports",
        data() {
            return {};
        },
        created(){
           this.pageName('Upload Reports')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/test_report/upload-reports.vue